import React, { useContext, useRef, useState } from 'react'
import emailjs from '@emailjs/browser';
import { useForm } from 'react-hook-form';
import { LanguageContext } from '../../../container/Language'
import loader from '../../../images/gif/loader.gif'

const EmailForm = ({ input: { fullName, email, message, buttonText, messageSuccess, messageError } }) => {
    const form = useRef()
    const { register, handleSubmit, clearErrors, formState: { errors } } = useForm()
    const [emailSent, setEmailSent] = useState(false)
    const { userLanguage } = useContext(LanguageContext)
    const template = userLanguage === 'en' ? 'template_g85vt8p' : 'template_bx6gmin'
    const [loading, setLoading] = useState(false)
    const [emailError, setEmailError] = useState(false)

    const sendEmail = (e) => {
        setLoading(true)
        setEmailError(false)
        emailjs.sendForm('service_j6zbork', template, form.current, '_0z_mKEp6nqQwHC6o')
            .then((result) => {
                setEmailSent(true)
                setLoading(false)
                clearErrors()
            }, (error) => {
                setEmailError(true)
                setLoading(false)
                console.log(error)
            });
    }

    return (
        <>


            <div className="row">
                <div className="col col-d-12 col-t-12 col-m-12 border-line-v">
                    <div className="contact_form">
                        <form ref={form} onSubmit={handleSubmit(sendEmail)}>
                            <div className="row">
                                <div className="col col-d-6 col-t-6 col-m-12">
                                    <div className="group-val">
                                        <input {...register("from_name", { required: "Please fill the name." })} className={(!emailSent && errors.from_name) ? "error" : ""} type="text" name="from_name" placeholder={fullName} />
                                    </div>
                                </div>
                                <div className="col col-d-6 col-t-6 col-m-12">
                                    <div className="group-val">
                                        <input {...register("from_email", { required: "Please fill the email." })} className={(!emailSent && errors.from_email) ? "error" : ""} type="email" name="from_email" placeholder={email} />
                                    </div>
                                </div>
                                <div className="col col-d-12 col-t-12 col-m-12">
                                    <div className="group-val">
                                        <textarea {...register("message", { required: "Please fill the message." })} className={(!emailSent && errors.message) ? "error" : ""} name="message" placeholder={message}></textarea>
                                    </div>
                                </div>
                            </div>
                            {!emailSent && (
                                <div className="align-left">
                                    {!loading && <button className="button" type="submit">
                                        <span className="text">{buttonText}</span>
                                        <span className="arrow"></span>
                                    </button>}
                                    {loading && <img src={loader} alt="loader" width="60" />}
                                </div>
                            )}
                        </form>
                        {emailSent && (<p style={{ color: '#00764b', fontSize: 'smaller' }}>{messageSuccess}</p>)}
                        {emailError && (<p style={{ color: '#c80000', fontSize: 'smaller' }}>{messageError}</p>)}
                    </div>
                </div>
                <div className="clear"></div>
            </div>
        </>
    )
}

export default EmailForm